import { useEffect, useState } from 'react';
import { getCategoriess, getCategoriesById } from '../services/CategoriesService'

export const useCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            const response = await getCategoriess();
            setCategories(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch categories');
        } finally {
            setLoading(false);
        }
        setLoading(false);
    };

    const fetchCategoriesById = async (id) => {
        try {
            const response = await getCategoriesById(id);
            setCategories(categories.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update categories');
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return { categories, loading, error, alert, fetchCategories, fetchCategoriesById };
}